<template >
  <div class="main">
    <img
      src="../assets/logo_login.png"
      style="width: 26vw; margin: 30px 0 0 50px"
    />
    <div class="background-container">
      <img
        src="../assets/background.png"
        style="width: 40vw; margin: 13vh 0 0 60px"
        alt=""
      />
      <div class="auth-container">
        <!-- 登录表单 -->
        <div v-if="activeTab === 'login'" class="login-form">
          <img
            src="../assets/welcome.png"
            style="width: 15vw; margin: 8vh 0 4vh 30px"
            alt=""
          />
          <h2 v-if="showAdminLogin">管理员登录</h2>
          <form
            @submit.prevent="handleLogin"
            v-if="!showResetPassword && !showAdminLogin"
          >
            <div class="form-group">
              <label for="login-phone">手机号</label>
              <input
                type="text"
                id="login-phone"
                v-model="loginForm.phone"
                placeholder="请输入手机号"
                required
              />
            </div>
            <div class="form-group">
              <label for="login-password">密码</label>
              <input
                type="password"
                id="login-password"
                v-model="loginForm.password"
                placeholder="请输入密码"
                required
              />
            </div>
            <div class="form-actions login-actions">
              <!-- <a
                href="#"
                @click.prevent="showResetPassword = true"
                class="forgot-password"
                >忘记密码?</a
              > -->
              <button type="submit" class="btn-primary login-btn">
                登 录 Log in
              </button>
            </div>
            <button @click="activeTab = 'register'" class="btn-primary-rig">
              没有账号，立即注册
            </button>
          </form>

          <!-- 管理员登录表单 -->
          <form @submit.prevent="handleAdminLogin" v-if="showAdminLogin">
            <div class="form-group">
              <label for="admin-password">管理员密码</label>
              <input
                type="password"
                id="admin-password"
                v-model="adminForm.password"
                placeholder="请输入管理员密码"
                required
              />
            </div>
            <div class="form-actions">
              <button type="submit" class="btn-primary">登录</button>
              <button
                type="button"
                class="btn-cancel"
                @click="showAdminLogin = false"
              >
                返回
              </button>
            </div>
          </form>

          <!-- 重置密码表单 -->
          <div v-if="showResetPassword" class="reset-password-form">
            <h3>重置密码</h3>
            <form @submit.prevent="handleResetPassword">
              <div class="form-group">
                <label for="reset-phone">手机号</label>
                <input
                  type="text"
                  id="reset-phone"
                  v-model="resetForm.phone"
                  placeholder="请输入注册手机号"
                  required
                />
              </div>
              <!-- <div class="form-group">
                <label for="reset-email">邮箱</label>
                <input
                  type="email"
                  id="reset-email"
                  v-model="resetForm.email"
                  placeholder="请输入注册邮箱"
                  required
                />
              </div> -->
              <div class="form-group">
                <label for="reset-code">验证码</label>
                <div class="code-input">
                  <input
                    type="text"
                    id="reset-code"
                    v-model="resetForm.code"
                    placeholder="请输入验证码"
                    required
                  />
                  <img
                    :src="captchaUrl"
                    alt="验证码"
                    class="captcha-image"
                    @click="refreshCaptcha"
                  />
                </div>
                <div class="captcha-tip">
                  验证码不区分大小写，点击图片可刷新
                </div>
              </div>
              <div class="form-group">
                <label for="new-password">新密码</label>
                <input
                  type="password"
                  id="new-password"
                  v-model="resetForm.newPassword"
                  placeholder="请输入新密码"
                  required
                />
              </div>
              <div class="form-actions">
                <button type="submit" class="btn-primary">确认重置</button>
                <button
                  type="button"
                  class="btn-cancel"
                  @click="showResetPassword = false"
                >
                  取消
                </button>
              </div>
            </form>
          </div>
        </div>

        <!-- 注册表单 -->
        <div v-if="activeTab === 'register'" class="register-form">
          <h2>注册Register</h2>
          <form @submit.prevent="handleRegister">
            <div class="form-group">
              <label for="register-name">姓名</label>
              <input
                type="text"
                id="register-name"
                v-model="registerForm.name"
                placeholder="请输入您的姓名"
                required
              />
            </div>
            <div class="form-group">
              <label for="register-phone">手机号</label>
              <input
                type="text"
                id="register-phone"
                v-model="registerForm.phone"
                placeholder="请输入手机号"
                required
              />
            </div>
            <!-- <div class="form-group">
              <label for="register-email">邮箱</label>
              <input
                type="email"
                id="register-email"
                v-model="registerForm.email"
                placeholder="请输入邮箱地址"
              />
            </div> -->
            <div class="form-group">
              <label for="register-password">密码</label>
              <input
                type="password"
                id="register-password"
                v-model="registerForm.password"
                placeholder="请输入密码"
                required
              />
            </div>
            <div class="form-group">
              <label for="register-confirm-password">确认密码</label>
              <input
                type="password"
                id="register-confirm-password"
                v-model="registerForm.confirmPassword"
                placeholder="请再次输入密码"
                required
              />
            </div>
            <div class="form-group">
              <label for="register-code">验证码</label>
              <div class="code-input">
                <input
                  type="text"
                  id="register-code"
                  v-model="registerForm.code"
                  placeholder="请输入验证码"
                  required
                />
                <img
                  :src="captchaUrl"
                  alt="验证码"
                  class="captcha-image"
                  @click="refreshCaptcha"
                />
              </div>
              <div class="captcha-tip">验证码不区分大小写，点击图片可刷新</div>
            </div>
            <div class="form-group">
              <label for="register-invite-code">邀请码（选填）</label>
              <input
                type="password"
                id="register-invite-code"
                v-model="registerForm.inviteCode"
                placeholder="请输入邀请码"
              />
            </div>
            <div class="form-actions">
              <button type="submit" class="btn-primary">完成注册</button>
            </div>
          </form>
        </div>

        <!-- 操作结果提示 -->
        <div v-if="message" class="message" :class="{ error: isError }">
          {{ message }}
        </div>
      </div>
    </div>
  </div>
  <div
    class="footer"
    style="
      background-color: #1e1e1e;
      padding: 5px 0;
      display: flex; /* 关键 1 */
      justify-content: center; /* 关键 2 */
      align-items: center;
      min-height: 3vh;
    "
  >
    <!-- 可选：垂直也居中 -->
    <a
      href="https://beian.miit.gov.cn/"
      target="_blank"
      rel="noopener noreferrer"
    >
      COPYRIGHT © 上海小梁同学文化有限公司 版权所有 备案号:
      沪ICP备2024045603号-2
    </a>
    <a
      href="https://beian.mps.gov.cn/#/query/webSearch"
      rel="noreferrer"
      target="_blank"
    >
      <img
        src="../assets/gongan.png"
        alt=""
        style="height: 12px; margin: 0 0 0 5px"
      />
      沪公网安备31011302008728号
    </a>
  </div>
</template>

<script>
export default {
  name: "AuthForm",
  data() {
    return {
      activeTab: "login", // 'login' 或 'register'
      showResetPassword: false,
      showAdminLogin: false,

      // 登录表单数据
      loginForm: {
        phone: "",
        password: "",
      },

      // 管理员登录表单数据
      adminForm: {
        password: "",
      },

      // 注册表单数据
      registerForm: {
        name: "",
        phone: "",
        email: "",
        password: "",
        confirmPassword: "",
        code: "",
        inviteCode: "",
      },

      // 重置密码表单数据
      resetForm: {
        phone: "",
        email: "",
        code: "",
        newPassword: "",
      },

      // 验证码倒计时
      registerCodeCountdown: 0,
      resetCodeCountdown: 0,

      // 消息提示
      message: "",
      isError: false,

      // 图形验证码 URL 和 token
      captchaUrl: "https://www.xiaoliangtongxue.cn/api/captcha",
      captchaToken: "",
    };
  },
  created() {
    if (localStorage.getItem("userName") !== null) {
      this.$router.push("/Home");
    }
    // 初始化验证码，获取 captchaToken
    this.refreshCaptcha();
  },
  watch: {
    // 监听标签页切换，切换时刷新验证码
    activeTab() {
      this.refreshCaptcha();
    },
  },
  methods: {
    // 处理管理员登录
    async handleAdminLogin() {
      if (!this.adminForm.password) {
        this.showMessage("请输入管理员密码", true);
        return;
      }

      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/admin-login",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              password: this.adminForm.password,
            }),
          }
        );

        const result = await response.json();

        if (result.success) {
          localStorage.setItem("userName", "admin");
          localStorage.setItem("userPhone", "admin");
          localStorage.setItem("userId", "admin");
          localStorage.setItem("isAdmin", true);

          this.$root.username = "admin";
          this.showMessage("登录成功");
          this.$router.push("/all-orders");
        } else {
          this.showMessage(result.message || "管理员密码错误", true);
        }
      } catch (error) {
        console.error("登录错误:", error);
        this.showMessage("网络错误，请稍后再试", true);
      }
    },

    // 处理普通用户登录
    async handleLogin() {
      if (!this.loginForm.phone || !this.loginForm.password) {
        this.showMessage("请输入手机号和密码", true);
        return;
      }

      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/login",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              phone: this.loginForm.phone,
              password: this.loginForm.password,
            }),
          }
        );

        const result = await response.json();

        if (result.success) {
          localStorage.setItem("userName", result.data.name);
          localStorage.setItem("userPhone", result.data.phone);
          localStorage.setItem("userEmail", result.data.email || "");
          localStorage.setItem("userId", result.data.id);
          localStorage.setItem("userPoor", result.data.poor);
          this.$root.username = result.data.name;
          this.showMessage(result.message || "登录成功");
          this.$router.push("/Home");
        } else {
          const phone = this.loginForm.phone;
          const password = this.loginForm.password;
          if (phone === "admin" && password === "xiaoliangtongxue") {
            localStorage.setItem("userName", "admin");
            localStorage.setItem("userPhone", "admin");
            localStorage.setItem("userId", "admin");
            localStorage.setItem("isAdmin", true);
            this.$root.username = "admin";
            this.showMessage("登录成功");
            this.$router.push("/all-orders");
            return;
          } else if (
            phone === "xiaoneiguanliyuan" &&
            password === "xiaoneiguanliyuan"
          ) {
            localStorage.setItem("userName", "xiaoneiguanliyuan");
            localStorage.setItem("userPhone", "校内管理员");
            localStorage.setItem("userId", "xiaoneiguanliyuan");
            localStorage.setItem("isXiaoneiUser", true);
            this.$root.username = "xiaoneiguanliyuan";
            this.showMessage("登录成功");
            this.$router.push("/xiaonei-orders");
            return;
          }
          this.showMessage(
            result.message || "登录失败，请检查手机号和密码",
            true
          );
        }
      } catch (error) {
        console.error("登录错误:", error);
        this.showMessage("网络错误，请稍后再试", true);
      }
    },

    // 处理注册
    async handleRegister() {
      // 表单验证
      if (!this.registerForm.name) {
        this.showMessage("请输入姓名", true);
        return;
      }

      if (!this.registerForm.phone) {
        this.showMessage("请输入手机号", true);
        return;
      }

      // 验证手机号格式
      if (!/^1\d{10}$/.test(this.registerForm.phone)) {
        this.showMessage("请输入正确的手机号格式", true);
        return;
      }

      if (!this.registerForm.password) {
        this.showMessage("请输入密码", true);
        return;
      }

      // 验证密码长度
      if (this.registerForm.password.length < 6) {
        this.showMessage("密码长度不能少于6位", true);
        return;
      }

      if (this.registerForm.password !== this.registerForm.confirmPassword) {
        this.showMessage("两次输入的密码不一致", true);
        return;
      }

      if (!this.registerForm.code) {
        this.showMessage("请输入验证码", true);
        return;
      }

      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/register",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              name: this.registerForm.name,
              phone: this.registerForm.phone,
              email: this.registerForm.email,
              password: this.registerForm.password,
              captcha: this.registerForm.code,
              captcha_token: this.captchaToken,
              inviteCode: this.registerForm.inviteCode,
            }),
          }
        );

        const result = await response.json();

        if (result.success) {
          this.showMessage(result.message || "注册成功");

          // 存储用户信息
          localStorage.setItem("userName", result.data.name);
          localStorage.setItem("userPhone", result.data.phone);
          localStorage.setItem("userEmail", result.data.email || "");
          localStorage.setItem("userId", result.data.id);

          // 更新App组件中的username
          this.$root.username = result.data.name;

          // 注册成功后延迟1秒跳转到首页
          setTimeout(() => {
            this.$router.push("/Home");
          }, 1000);
        } else {
          this.showMessage(result.message || "注册失败", true);
          // 刷新验证码
          this.refreshCaptcha();
        }
      } catch (error) {
        console.error("注册错误:", error);
        this.showMessage("网络错误，请稍后重试", true);
        // 刷新验证码
        this.refreshCaptcha();
      }
    },

    // 处理重置密码
    async handleResetPassword() {
      // 表单验证
      if (!this.resetForm.phone) {
        this.showMessage("请输入手机号", true);
        return;
      }

      // 验证手机号格式
      if (!/^1\d{10}$/.test(this.resetForm.phone)) {
        this.showMessage("请输入正确的手机号格式", true);
        return;
      }

      // if (!this.resetForm.email) {
      //   this.showMessage("请输入邮箱", true);
      //   return;
      // }

      // 验证邮箱格式
      // if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.resetForm.email)) {
      //   this.showMessage("请输入正确的邮箱格式", true);
      //   return;
      // }

      if (!this.resetForm.code) {
        this.showMessage("请输入验证码", true);
        return;
      }

      if (!this.resetForm.newPassword) {
        this.showMessage("请输入新密码", true);
        return;
      }

      // 验证密码长度
      if (this.resetForm.newPassword.length < 6) {
        this.showMessage("新密码长度不能少于6位", true);
        return;
      }

      try {
        const response = await fetch(
          "https://www.xiaoliangtongxue.cn/api/reset-password",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({
              phone: this.resetForm.phone,
              email: this.resetForm.email,
              new_password: this.resetForm.newPassword,
              captcha: this.resetForm.code,
              captcha_token: this.captchaToken,
            }),
          }
        );

        const result = await response.json();

        if (result.success) {
          this.showMessage(result.message || "密码重置成功");

          // 自动填充登录表单中的手机号
          this.loginForm.phone = result.user.phone;

          // 清空重置密码表单
          this.resetForm = {
            phone: "",
            email: "",
            code: "",
            newPassword: "",
          };

          // 关闭重置密码表单，显示登录表单
          setTimeout(() => {
            this.showResetPassword = false;
          }, 1000);
        } else {
          this.showMessage(result.message || "密码重置失败", true);
          // 刷新验证码
          this.refreshCaptcha();
        }
      } catch (error) {
        console.error("重置密码错误:", error);
        this.showMessage("网络错误，请稍后重试", true);
        // 刷新验证码
        this.refreshCaptcha();
      }
    },

    // 发送注册验证码
    sendRegisterCode() {
      if (!this.registerForm.phone) {
        this.showMessage("请输入手机号", true);
        return;
      }

      // 这里替换为实际的发送验证码API调用
      console.log("发送注册验证码到:", this.registerForm.phone);
      this.showMessage("验证码已发送");

      // 开始倒计时
      this.startRegisterCountdown();
    },

    // 发送重置密码验证码
    sendResetCode() {
      if (!this.resetForm.phone) {
        this.showMessage("请输入手机号", true);
        return;
      }

      // 这里替换为实际的发送验证码API调用
      console.log("发送重置密码验证码到:", this.resetForm.phone);
      this.showMessage("验证码已发送");

      // 开始倒计时
      this.startResetCountdown();
    },

    // 开始注册验证码倒计时
    startRegisterCountdown() {
      this.registerCodeCountdown = 60;
      const timer = setInterval(() => {
        this.registerCodeCountdown--;
        if (this.registerCodeCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    // 开始重置密码验证码倒计时
    startResetCountdown() {
      this.resetCodeCountdown = 60;
      const timer = setInterval(() => {
        this.resetCodeCountdown--;
        if (this.resetCodeCountdown <= 0) {
          clearInterval(timer);
        }
      }, 1000);
    },

    // 显示消息提示
    showMessage(msg, isError = false) {
      this.message = msg;
      this.isError = isError;

      // 3秒后自动消失
      setTimeout(() => {
        this.message = "";
        this.isError = false;
      }, 3000);
    },

    // 刷新验证码
    refreshCaptcha() {
      // 添加时间戳避免缓存
      const timestamp = new Date().getTime();
      const url = `https://www.xiaoliangtongxue.cn/api/captcha?t=${timestamp}`;

      // 使用 fetch 获取验证码，同时获取 token 和图片
      fetch(url, {
        method: "GET",
        credentials: "include",
      })
        .then((response) => {
          // 从响应头获取 token
          const token = response.headers.get("X-Captcha-Token");
          if (token) {
            this.captchaToken = token;
          }
          // 获取图片 blob
          return response.blob();
        })
        .then((blob) => {
          // 创建图片 URL
          this.captchaUrl = URL.createObjectURL(blob);
        })
        .catch((error) => {
          console.error("获取验证码失败:", error);
          // 如果 fetch 失败，回退到直接设置 URL
          this.captchaUrl = url;
        });
    },
  },
};
</script>

<style scoped>
.main {
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  height: 95vh;
  margin: 0;
  background-color: #f5f5f500;
}
.background-container {
  width: 80vw;
  height: 80vh;
  background-color: #e8e8e8;
  position: absolute;
  top: 13vh;
  left: 10vw;
  border-radius: 16px;
}

.auth-container {
  width: 25vw;
  overflow: auto;
  position: absolute;
  top: 2vh;
  right: 5vw;
  padding: 20px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;
}

.auth-tabs {
  display: flex;
  margin-bottom: 30px;
  border-bottom: 2px solid #f0f0f0;
}

.auth-tabs button {
  flex: 1;
  padding: 12px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  position: relative;
  transition: all 0.3s ease;
}

.auth-tabs button.active {
  color: #000000;
  font-weight: 600;
}

.auth-tabs button.active::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #000000;
  transition: all 0.3s ease;
}

h2,
h3 {
  margin: 0 0 20px;
  color: #333;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
}

.form-group label {
  display: block;
  color: #333;
  font-size: 14px;
  font-weight: 500;
}

.form-group input {
  width: 100%;
  padding: 8px 0;
  border: 0px solid #e8e8e8;
  box-sizing: border-box;
  font-size: 13px;
  transition: all 0.3s ease;
  background-color: #fff;
  border-bottom: 2px solid #030303;
  margin-bottom: 8px;
}

.form-group input:focus {
  outline: none;
}

.code-input {
  display: flex;
  gap: 12px;
  align-items: center;
}

.code-input input {
  flex: 1;
}

.captcha-image {
  height: 40px;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.captcha-image:hover {
  opacity: 0.8;
}

.captcha-tip {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
  margin-left: 4px;
}

.btn-send-code {
  padding: 0 20px;
  background-color: #f5f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
  color: #333333;
  transition: all 0.3s ease;
}

.btn-send-code:hover:not(:disabled) {
  background-color: #e8e8e8;
  border-color: #333333;
}

.btn-send-code:disabled {
  background-color: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}

.form-actions {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.login-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.forgot-password {
  font-size: 13px;
  color: #333333;
  text-decoration: none;
  transition: all 0.3s ease;
  margin-left: auto;
  white-space: nowrap;
}

.forgot-password:hover {
  color: #000000;
}

.btn-primary {
  width: 100%;
  padding: 10px 0;
  background-color: #000000;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.login-btn {
  flex: 1;
}

.btn-primary-rig {
  margin-top: 10px;
  width: 100%;
  padding: 10px 0;
  color: black;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-primary-rig:hover {
  background-color: #c7c7c7;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-primary:hover {
  background-color: #333333;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.btn-cancel {
  width: 100%;
  padding: 10px 0;
  background-color: #f5f5f5;
  color: #666;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.btn-cancel:hover {
  background-color: #fafafa;
  border-color: #d9d9d9;
  transform: translateY(-1px);
}

.message {
  margin-top: 20px;
  padding: 12px 20px;
  border-radius: 8px;
  background-color: #f5f5f5;
  color: #333333;
  text-align: center;
  font-size: 14px;
  transition: all 0.3s ease;
}

.message.error {
  background-color: #f5f5f5;
  color: #666666;
}

a {
  color: #333333;
  text-decoration: none;
  transition: all 0.3s ease;
}

a:hover {
  color: #000000;
  text-decoration: none;
}

/* 添加表单切换动画 */
.login-form,
.register-form {
  animation: fadeIn 0.3s ease;
  height: 72vh;
  width: 85%;
  margin: 0 auto;
}

.register-form h2 {
  font-weight: 500;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.footer a {
  color: rgb(201, 199, 199);
  font-size: 12px;
  text-decoration: none; /* 取消下划线 */
  text-align: center; /* 水平居中 */
}
</style>